(function () {

  'use strict';

  function pxContextMenu($timeout, $window) {
    return {
      restrict: 'EA',
      scope: {
        menuContent: '=menuContent',
        menuSpecs: '=menuSpecs',
        callback: '&callback'
      },
      templateUrl: 'app/directives/contextMenu/context-menu.template.html',
      link: function (scope) {

        (function () {
          initContextMenu();
        })();

        scope.$watch(function () {
          return scope.menuSpecs;
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            initContextMenu();
          }
        });

        function initContextMenu() {
          scope.selectedItem = null;
          scope.contextContentPosition = null;
          adjustMenuPosition(scope.menuSpecs.position.top);
        };

        function adjustMenuPosition() {
          $timeout(function () {
            const totalWidth = $window.innerWidth;
            let left = scope.menuSpecs.position.left;
            if (totalWidth / 2 > scope.menuSpecs.position.left) {
              // place menu to the right of the click event
              left += 15;
            } else {
              // place menu to the left of the click event
              const menuWidth = angular.element('.context-menu').innerWidth();
              left -= menuWidth + 20;
            }
            const totalHeight = $window.innerHeight;
            let top = scope.menuSpecs.position.top;
            if (totalHeight / 2 > scope.menuSpecs.position.top) {
              // place menu under the click event
              top += 15;
            } else {
              // place menu over the click event
              const menuHeight = angular.element('.context-menu').innerHeight();
              top -= menuHeight;
            }
            angular.element('.context-menu').css({ top, left, display: 'block' });
          });
        }

        scope.selectMenuItem = function (event, menuItem) {
          scope.menuContent.menuItems.forEach(function (item) {
            item.selected = false;
          });
          menuItem.selected = true;
          scope.selectedItem = menuItem;
          positionContextContent(event);
        };

        function positionContextContent(event) {
          scope.contextContentPosition = {
            left: event.clientX,
            top: event.clientY
          };
          scope.closePopupOutside();
        }

        scope.closePopupOutside = function () {
          if (scope.selectedItem) {
            scope.callback({ selectedContextMenuItem: scope.selectedItem, contextContentPosition: scope.contextContentPosition, contextContent: scope.menuContent });
          } else {
            scope.callback({ selectedContextMenuItem: null, contextContentPosition: null, contextContent: null }); // click outside
          }
        };

      }
    };
  }

  pxContextMenu.$inject = ['$timeout', '$window'];

  angular
    .module('printix-admin')
    .directive('pxContextMenu', pxContextMenu);

})();
